import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35b60adc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "education-block" }
const _hoisted_2 = { class: "split-section" }
const _hoisted_3 = { class: "split-section fst-italic" }
const _hoisted_4 = { class: "relevant-coursework" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Relevant Coursework:", -1))




export default /*#__PURE__*/_defineComponent({
  __name: 'EducationBlock',
  props: {
  name: {
    type: String,
    default: '',
  },
  graduationDate: {
    type: String,
    default: '',
  },
  degreeTitle: {
    type: String,
    default: '',
  },
  location: {
    type: String,
    default: '',
  },
  relevantCoursework: {
    type: String,
    default: '',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", null, _toDisplayString(__props.name), 1),
        _createElementVNode("h3", null, _toDisplayString(__props.graduationDate), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", null, _toDisplayString(__props.degreeTitle), 1),
        _createElementVNode("p", null, _toDisplayString(__props.location), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("p", null, _toDisplayString(__props.relevantCoursework), 1)
      ])
    ])
  ]))
}
}

})